/* CP-02 (CU-86d42x66p) — Buy again reroute controller.
 * Classic script (no ESM). Nothing here touches window, document, location or
 * sessionStorage at load time — every such access sits inside a function that
 * is only called when the caller invokes it.
 */

var REORDER_FLAG_KEY = 'cre-reorder';

function isThemeCausedArrival(referrer, origin) {
	try {
		if (!referrer) {
			return false;
		}
		var referrerUrl = new URL(referrer);
		return referrerUrl.origin === origin;
	} catch (e) {
		return false;
	}
}

function resolveDestination(settingValue, cartPath, currentPath, currentOrigin) {
	try {
		var FALLBACK = '/collections/menu';

		// Rule 2: missing or blank-after-trim falls back.
		var value = settingValue;
		if (value === undefined || value === null || String(value).trim() === '') {
			value = FALLBACK;
		}

		// Rule 3: must resolve against currentOrigin and match it.
		var resolvedUrl;
		try {
			resolvedUrl = new URL(value, currentOrigin);
		} catch (e) {
			resolvedUrl = null;
		}
		if (!resolvedUrl || resolvedUrl.origin !== currentOrigin) {
			resolvedUrl = new URL(FALLBACK, currentOrigin);
		}

		// Rule 4: pathname equal to cartPath or currentPath falls back.
		if (resolvedUrl.pathname === cartPath || resolvedUrl.pathname === currentPath) {
			resolvedUrl = new URL(FALLBACK, currentOrigin);
		}

		// Rule 5: terminal guard fails open.
		if (resolvedUrl.pathname === currentPath) {
			return null;
		}

		return resolvedUrl.pathname + resolvedUrl.search + resolvedUrl.hash;
	} catch (e) {
		return null;
	}
}

/* CP-03 (CU-86d42x66p) — Cart reconciliation: reduce a reordered cart down to
 * purchasable lines and re-render the drawer server-side when anything was
 * removed. None of the three exported pure functions below touches window,
 * document, location or the network, and none of them throws.
 */

function consumeReorderFlag(storage) {
	var flagged = false;
	try {
		flagged = storage.getItem(REORDER_FLAG_KEY) === '1';
	} catch (e) {
		return false;
	}
	if (flagged) {
		try {
			storage.removeItem(REORDER_FLAG_KEY);
		} catch (e) {
			// Clearing failed, but the flag was read as set — still true.
		}
	}
	return flagged;
}

function handlesFromCartLines(lines) {
	var handles = [];
	if (!lines) {
		return handles;
	}
	for (var i = 0; i < lines.length; i++) {
		var line = lines[i];
		if (!line || !line.url) {
			continue;
		}
		var handle = extractProductHandle(line.url);
		if (!handle) {
			continue;
		}
		if (handles.indexOf(handle) === -1) {
			handles.push(handle);
		}
	}
	return handles;
}

function extractProductHandle(url) {
	try {
		// Strip query string and hash without needing an absolute URL.
		var withoutHash = String(url).split('#')[0];
		var withoutQuery = withoutHash.split('?')[0];
		var segments = withoutQuery.split('/').filter(function (segment) {
			return segment.length > 0;
		});
		var productsIndex = segments.indexOf('products');
		if (productsIndex === -1 || productsIndex + 1 >= segments.length) {
			return null;
		}
		var handle = segments[productsIndex + 1];
		return handle || null;
	} catch (e) {
		return null;
	}
}

function unavailableLineKeys(lines, productsByHandle) {
	var result = [];
	if (!lines) {
		return result;
	}
	var map = productsByHandle || {};
	for (var i = 0; i < lines.length; i++) {
		var line = lines[i];
		if (!line) {
			continue;
		}
		var handle = extractProductHandle(line.url);
		if (!handle || !Object.prototype.hasOwnProperty.call(map, handle)) {
			// Absent from the map: lookup failed or no url — leave it alone.
			continue;
		}
		var product = map[handle];
		if (product === null) {
			result.push(line.key);
			continue;
		}
		var variants = (product && product.variants) || [];
		var matched = null;
		for (var j = 0; j < variants.length; j++) {
			if (variants[j] && variants[j].id === line.variant_id) {
				matched = variants[j];
				break;
			}
		}
		if (!matched || matched.available !== true) {
			result.push(line.key);
		}
	}
	return result;
}

/* FIX-06 (CU-86d42x66p) — Never run the reorder controller on the cart page
 * itself; the head script's location.replace is what leaves it.
 */
function isCartPath(currentPath, cartUrl) {
	if (typeof currentPath !== 'string') {
		return false;
	}
	var cart = cartUrl;
	if (cart === undefined || cart === null || cart === '') {
		cart = '/cart';
	}
	var normalize = function (path) {
		if (path.length > 1 && path.charAt(path.length - 1) === '/') {
			return path.slice(0, -1);
		}
		return path;
	};
	return normalize(currentPath) === normalize(String(cart));
}

/* CP-04 (CU-86d42x66p) — Presenter: opens the cart drawer and renders the
 * ratified check-your-cart message, as the last step of the controller's
 * chain so no server re-render it performed can clear the message.
 */

function noticeTextFrom(cartStrings) {
	try {
		if (!cartStrings) {
			return null;
		}
		var value = cartStrings.reorderCheckCart;
		if (typeof value !== 'string') {
			return null;
		}
		var trimmed = value.trim();
		if (trimmed === '') {
			return null;
		}
		return trimmed;
	} catch (e) {
		return null;
	}
}

// The drawer is opened once per reorder arrival. Later presenter calls (after the
// server re-render wipes the notice container) only re-write the copy, so a
// drawer the customer has since closed stays closed.
var reorderDrawerOpened = false;

function presentReorderNotice(summary) {
	try {
		return customElements.whenDefined('cart-drawer').then(function () {
			var drawer = document.querySelector('cart-drawer');
			if (!drawer) {
				return;
			}
			if (!reorderDrawerOpened) {
				reorderDrawerOpened = true;
				if (!drawer.classList.contains('active')) {
					drawer.open();
				}
			}

			var text = noticeTextFrom(window.cartStrings);
			if (text === null) {
				return;
			}
			var notice = document.querySelector('#CartDrawer-ReorderNotice');
			if (!notice) {
				return;
			}
			// The copy comes from an `_html` locale key, which Shopify leaves unescaped; innerHTML matches the theme's own handling of such strings.
			notice.innerHTML = text;
		});
	} catch (e) {
		return Promise.resolve();
	}
}

/**
 * Returns true when the space-separated class list in `className` contains
 * the token `is-empty`, false otherwise (including for any non-string
 * input). Never throws.
 */
function emptyStateFromClassName(className) {
	if (typeof className !== 'string') {
		return false;
	}
	return className.split(/\s+/).indexOf('is-empty') !== -1;
}

// Publishes on the global as CreReorder. As a top-level `var` in a classic
// (non-module) script this becomes a property of `window` in the browser
// without touching `window` directly here.
var CreReorder = {
	isThemeCausedArrival: isThemeCausedArrival,
	resolveDestination: resolveDestination,
	REORDER_FLAG_KEY: REORDER_FLAG_KEY,
	consumeReorderFlag: consumeReorderFlag,
	handlesFromCartLines: handlesFromCartLines,
	unavailableLineKeys: unavailableLineKeys,
	noticeTextFrom: noticeTextFrom,
	emptyStateFromClassName: emptyStateFromClassName,
	isCartPath: isCartPath,
	onReorderComplete: presentReorderNotice
};

/**
 * Wraps `fetch` with an 8s abort timeout on browsers that support the
 * standard feature (Baseline 2022); falls back to a plain, unbounded
 * `fetch` otherwise. Every network call in this file routes through here.
 */
function boundedFetch(url, init) {
	var options = init ? Object.assign({}, init) : {};
	if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') { options.signal = AbortSignal.timeout(8000); }
	return fetch(url, options);
}

/**
 * Fetches JSON, at most `limit` requests in flight at a time, and builds a
 * handle -> parsed-body map per the CP-03 contract:
 *  - 2xx maps the handle to the parsed body.
 *  - 404 or 410 maps the handle to null.
 *  - any other outcome (5xx, timeout, network failure) omits the handle.
 */
function fetchProductsByHandle(handles, limit) {
	var map = {};
	var index = 0;

	function next() {
		if (index >= handles.length) {
			return Promise.resolve();
		}
		var handle = handles[index];
		index++;
		return boundedFetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
			.then(function (res) {
				if (res.status === 404 || res.status === 410) {
					map[handle] = null;
					return null;
				}
				if (!res.ok) {
					// Leave the handle out of the map entirely.
					return null;
				}
				return res
					.json()
					.then(function (body) {
						map[handle] = body;
					})
					.catch(function () {
						// Unparseable body: treat as an incomplete lookup.
					});
			})
			.catch(function () {
				// Network failure: leave the handle out of the map entirely.
			})
			.then(next);
	}

	var workers = [];
	var workerCount = Math.min(limit, handles.length);
	for (var i = 0; i < workerCount; i++) {
		workers.push(next());
	}
	return Promise.all(workers).then(function () {
		return map;
	});
}

/**
 * Removes cart lines sequentially by key via POST /cart/change.js, quantity 0.
 * Stops on the first non-2xx response. Returns the keys actually removed.
 */
function removeLinesSequentially(keys) {
	var removed = [];

	function removeNext(i) {
		if (i >= keys.length) {
			return Promise.resolve(removed);
		}
		return boundedFetch('/cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ id: keys[i], quantity: 0 })
		})
			.then(function (res) {
				if (!res.ok) {
					return removed;
				}
				removed.push(keys[i]);
				return removeNext(i + 1);
			})
			.catch(function () {
				return removed;
			});
	}

	return removeNext(0);
}

/**
 * Re-renders the cart drawer from the server, matching the pattern already
 * in this theme at assets/cre-product-card.js:328-333.
 */
function reRenderCartDrawer() {
	return boundedFetch('/cart?section_id=cart-drawer', { method: 'get' })
		.then(function (res) {
			return res.text();
		})
		.then(function (text) {
			var parsed = new DOMParser().parseFromString(text, 'text/html');
			var source = parsed.querySelector('#CartDrawer');
			var target = document.querySelector('#CartDrawer');
			if (source && target) {
				target.innerHTML = source.innerHTML;
				var parsedElement = parsed.querySelector('cart-drawer');
				var live = document.querySelector('cart-drawer');
				if (parsedElement && live) {
					live.classList.toggle('is-empty', emptyStateFromClassName(parsedElement.className));
				}

				var liveBubble = document.querySelector('#cart-icon-bubble');
				if (liveBubble) {
					boundedFetch('/cart?section_id=cart-icon-bubble', { method: 'get' })
						.then(function (res) {
							return res.text();
						})
						.then(function (bubbleHtml) {
							var bubbleSection = new DOMParser()
								.parseFromString(bubbleHtml, 'text/html')
								.querySelector('.shopify-section');
							if (bubbleSection) {
								liveBubble.innerHTML = bubbleSection.innerHTML;
							}
						})
						.catch(function () {
							// A failed bubble refresh leaves the header count as rendered; the drawer is already correct.
						});
				}

				var liveDrawer = document.querySelector('cart-drawer');
				var overlay = liveDrawer ? liveDrawer.querySelector('#CartDrawer-Overlay') : null;
				if (liveDrawer && overlay && typeof liveDrawer.close === 'function') {
					overlay.addEventListener('click', liveDrawer.close.bind(liveDrawer));
				}

				if (typeof discountApply === 'function') {
					discountApply();
				}
			}
		});
}

function runReorderReconciliation() {
	function complete(removedKeys, reRendered) {
		try {
			CreReorder.onReorderComplete({ removedKeys: removedKeys, reRendered: reRendered });
		} catch (e) {
			// The chain's last step must never itself throw out of the wrapper.
		}
	}

	try {
		if (isCartPath(location.pathname, window.routes && window.routes.cart_url)) {
			return;
		}
		if (!consumeReorderFlag(window.sessionStorage)) {
			return;
		}
		if (!document.querySelector('cart-drawer')) {
			return;
		}

		presentReorderNotice();

		Promise.resolve()
			.then(function () {
				return boundedFetch('/cart.js', { headers: { Accept: 'application/json' } });
			})
			.then(function (res) {
				if (!res.ok) {
					complete([], false);
					return null;
				}
				return res.json().then(function (cart) {
					var items = (cart && cart.items) || [];
					if (items.length === 0) {
						complete([], false);
						return null;
					}

					var handles = handlesFromCartLines(items);
					return fetchProductsByHandle(handles, 4).then(function (productsByHandle) {
						var keysToRemove = unavailableLineKeys(items, productsByHandle);
						if (keysToRemove.length === 0) {
							complete([], false);
							return null;
						}

						return removeLinesSequentially(keysToRemove).then(function (removedKeys) {
							if (removedKeys.length === 0) {
								complete([], false);
								return null;
							}
							return reRenderCartDrawer()
								.then(function () {
									complete(removedKeys, true);
								})
								.catch(function () {
									complete(removedKeys, false);
								});
						});
					});
				});
			})
			.catch(function () {
				complete([], false);
			});
	} catch (e) {
		complete([], false);
	}
}

if (typeof document !== 'undefined' && typeof document.addEventListener === 'function') {
	document.addEventListener('DOMContentLoaded', runReorderReconciliation);
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = CreReorder;
}
